<!-- Das Side Sheet der App — EIN Rahmen fuer alle drei Apps. Er stand bis 2026-08-24 dreimal
     wortgleich in den App-Navigationen; wer eines braucht, ruft nur noch `SidesheetService.open(...)`.
     Geschlossen rendert er nichts.

     Die Referenz heisst `#sidesheetDrawer` und NICHT `#drawer`: die Navigations-Sidenav weiter
     unten traegt `#drawer`, und zwei gleichnamige Referenzen in EINER Vorlage sind kein Fehler,
     den der Compiler meldet — Angular nimmt still die erste (`maybeDeclare` im Template-Binder).
     Als beide `#drawer` hiessen, zeigte deshalb das `drawer.toggle()` des Hamburger-Knopfs auf
     dieses Sheet statt auf das Menue: auf dem Handy liess sich die Navigation nicht mehr oeffnen.
     Vorher lagen die beiden in getrennten Komponenten und kollidierten nie.

     Ohne ausdruecklichen `mode` richtet sich der Rahmen nach der Fenstergroesse: angedockt am
     Desktop, als Overlay auf dem Handy — ein angedocktes 30-rem-Sheet schoebe dort den Inhalt,
     den es erklaert, aus dem Bild.

     Die Toolbar steht VOR dem Container, nicht in ihm: so beginnt das Sheet unter ihr, und ein
     angedocktes Sheet schiebt nur noch die Inhaltsflaeche zur Seite. Bis 2026-10-02 lag die ganze
     Huelle im Container, und beim Oeffnen des Supports wanderten Suchfeld, Logo-Spalte und
     Seitenleiste mit (Befund Tim: „backt auf der linken Seite rum, faehrt von links rein"). -->
@let _sidesheet = sidesheets.sidesheet();
<!-- Ueber dem Side-Sheet-Rahmen statt in ihm: so laeuft der Streifen auch bei offenem Sheet ueber die
     volle Breite. Seine Hoehe ziehen die `100vh`-Flaechen ab (`--stage-bar-height` im SCSS). -->
<lib-stage-bar></lib-stage-bar>
<mat-toolbar color="primary">
  <div class="toolbar-container" [ngClass]="{ 'toolbar-container-handset': isHandset$ | async }">
    @if (logoUrl(); as logo) {
      <img
        class="toolbar-logo toolbar-logo-bild pointer"
        [class.toolbar-logo-handset]="isHandset$ | async"
        [src]="logo"
        alt="Logo"
        routerLink="/"
      />
    } @else {
      <div class="toolbar-logo pointer" [class.toolbar-logo-handset]="isHandset$ | async" routerLink="/"></div>
    }

    <div class="flex flex-center toolbar-mitte">
      @if (isHandset$ | async) {
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()" matTooltip="Navigationsmenü">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
      }
      @for (template of toolbarService.toolbarTemplateStack(); track template; let last = $last) {
        <!-- Only hide to keep the state alive -->
        <div class="full-width" [ngClass]="{ hidden: !last }">
          @if (template) {
            <ng-container *ngTemplateOutlet="template"></ng-container>
          } @else {
            <span>{{ appTitle() }}</span>
          }
        </div>
      } @empty {
        <span>{{ appTitle() }}</span>
      }
    </div>

    <div class="flex flex-center toolbar-end">
      <lib-error-center-button [saniupEmployee]="saniupEmployee()"></lib-error-center-button>
      @let template = actionsTemplate();
      @if (template) {
        <ng-container *ngTemplateOutlet="template"></ng-container>
      }
      <lib-profile-widget [profil]="profil()"></lib-profile-widget>
    </div>
  </div>
</mat-toolbar>
<mat-drawer-container class="sidesheet-container" (backdropClick)="sidesheets.close()">
  <mat-drawer
    class="sidesheet-drawer"
    [style.--size]="_sidesheet?.size"
    [mode]="_sidesheet?.mode ?? ((isHandset$ | async) ? 'over' : 'side')"
    [opened]="!!_sidesheet"
    position="end"
    (keydown.esc)="sidesheets.close()"
    #sidesheetDrawer
  >
    @if (_sidesheet; as sheet) {
      <section class="sidesheet-flaeche" aria-labelledby="sidesheet-titel">
        <header class="sidesheet-kopf" [class.sidesheet-kopf--zurueck]="!!sheet.zurueck">
          @if (sheet.zurueck; as zurueck) {
            <button type="button" matIconButton (click)="zurueck()" matTooltip="Zurück" aria-label="Zurück">
              <mat-icon>arrow_back</mat-icon>
            </button>
          }
          <div class="sidesheet-kopf-text">
            <h2 id="sidesheet-titel" class="mat-title-large" (click)="sheet.titleClick?.()">{{ sheet.title }}</h2>
            @if (sheet.untertitel) {
              <p class="mat-body-medium sidesheet-untertitel">{{ sheet.untertitel }}</p>
            }
          </div>
          @if (sheet.actions; as actions) {
            <ng-container *ngTemplateOutlet="actions"></ng-container>
          }
          <button type="button" matIconButton (click)="sidesheets.close()" matTooltip="Schließen" aria-label="Side Sheet schließen">
            <mat-icon>close</mat-icon>
          </button>
        </header>
        <div class="sidesheet-rumpf" [class.sidesheet-rumpf--randlos]="sheet.randlos">
          <ng-container *ngTemplateOutlet="sheet.templateRef; context: { drawer: sidesheetDrawer }"></ng-container>
        </div>
      </section>
    }
  </mat-drawer>
  <mat-drawer-content>
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        #drawer
        class="sidenav"
        fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [disableClose]="(isHandset$ | async) === false"
        [opened]="(isHandset$ | async) === false"
      >
        <div class="flex flex-column sidenav-nav">
          <div>
            @let _layout = layoutEffektiv();
            @let _nurIcons = nurIcons();
            @let _fabTemplate = fabTemplate();
            @if (_fabTemplate) {
              <!-- Das Layout geht als Kontext mit: in der Liste ist der Knopf breit und beschriftet. -->
              <div class="main-fab-container">
                <ng-container *ngTemplateOutlet="_fabTemplate; context: { $implicit: _layout }"></ng-container>
              </div>
            }
            <nav
              class="navigation"
              [class.navigation-list]="_layout === 'list'"
              [class.navigation-arbeitsliste]="layout() === 'responsive'"
            >
              <lib-navigation-button [navItem]="homeItem()" [layout]="_layout" [nurIcons]="_nurIcons"></lib-navigation-button>

              @if (_layout === 'list' && _navGroups().sections; as sections) {
                @for (section of sections; track section.label) {
                  <div class="nav-section">
                    <p class="nav-section-label mat-label-small">{{ section.label }}</p>
                    @for (item of section.items; track item.route) {
                      <lib-navigation-button [navItem]="item" [layout]="_layout"></lib-navigation-button>
                    }
                  </div>
                }
              } @else {
                @for (navItem of flacheEintraege(); track $index) {
                  <lib-navigation-button [navItem]="navItem" [layout]="_layout" [nurIcons]="_nurIcons"></lib-navigation-button>
                }
              }
            </nav>
          </div>

          <lib-nav-action-list [class.arbeitsliste]="layout() === 'responsive' && layoutEffektiv() === 'list'"></lib-nav-action-list>
        </div>
      </mat-sidenav>
      <mat-sidenav-content class="sidenav-content">
        <div class="fluff">
          <div class="main-content" [class.main-content--lg]="(isHandset$ | async) === false">
            <div #scrollContainer class="overflow" cdkScrollable>
              <!-- Im Scroll-Container statt zwischen Toolbar und Sidenav: die Hoehen dort rechnen mit
               `100vh - toolbar`, ein zusaetzlicher Streifen davor schoebe die ganze Flaeche aus dem
               Fenster. Sticky, damit er beim Scrollen nicht verloren geht. -->
              <lib-connection-banner class="connection-banner"></lib-connection-banner>
              <router-outlet></router-outlet>
              <div #scrollSentinel class="scroll-sentinel" aria-hidden="true"></div>
            </div>
            @if (showScrollIndicator()) {
              <div class="scroll-indicator" aria-hidden="true">
                <mat-icon>expand_more</mat-icon>
              </div>
            }
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-drawer-content>
</mat-drawer-container>
